import { tw } from 'utils/classnames'

type IconProps = React.ComponentProps<'svg'>

const AIDA_ICON_PATH =
  'M12.49316 12.49316c0.39052-0.39053 1.02354-0.39053 1.41407 0 0.3904 0.39053 0.39048 1.02358 0 1.41407-2.19049 2.19036-5.72357 2.19036-7.91406 0-0.39048-0.39048-0.3904-1.02353 0-1.41407 0.39052-0.39053 1.02354-0.39053 1.41406 0 1.40944 1.40931 3.67649 1.40931 5.08594 0z m-6.99316-7.49316c0.55228 0 1 0.44772 1 1l0 1.5c0 0.55229-0.44772 1-1 1-0.55228 0-1-0.44772-1-1l0-1.5c0-0.55228 0.44772-1 1-1z m9 0c0.55228 0 1 0.44772 1 1l0 1.5c0 0.55229-0.44771 1-1 1-0.55228 0-1-0.44772-1-1l0-1.5c0-0.55228 0.44772-1 1-1z m-0.25879-5c0.80497-0.00001 1.46955-0.00027 2.01074 0.04395 0.56206 0.04593 1.07915 0.14433 1.56446 0.3916 0.7525 0.38347 1.36458 0.99554 1.74804 1.74804 0.24728 0.4853 0.34567 1.0024 0.3916 1.56446 0.04422 0.54119 0.04396 1.20578 0.04395 2.01074l0 8.48242c0.00001 0.80496 0.00027 1.46955-0.04395 2.01074-0.04593 0.56206-0.14433 1.07915-0.3916 1.56446-0.38347 0.7525-0.99554 1.36458-1.74804 1.74804-0.48531 0.24728-1.0024 0.34567-1.56446 0.3916-0.54119 0.04422-1.20578 0.04396-2.01074 0.04395l-8.48242 0c-0.805 0.00001-1.46953 0.00027-2.01074-0.04395-0.56206-0.04593-1.07915-0.14433-1.56446-0.3916-0.7525-0.38347-1.36458-0.99554-1.74804-1.74804-0.24727-0.48531-0.34567-1.0024-0.3916-1.56446-0.04422-0.5412-0.04396-1.20577-0.04395-2.01074l0-8.48242c-0.00001-0.80497-0.00027-1.46955 0.04395-2.01074 0.04593-0.56206 0.14433-1.07915 0.3916-1.56446 0.38347-0.75251 0.99554-1.36458 1.74804-1.74804 0.4853-0.24727 1.0024-0.34567 1.56446-0.3916 0.5412-0.04422 1.20577-0.04396 2.01074-0.04395l8.48242 0z m-8.4414 2c-0.85639 0-1.43863 0.00035-1.88868 0.03711-0.43842 0.03582-0.66294 0.10097-0.81933 0.18066-0.37625 0.19173-0.68229 0.49777-0.87403 0.87403-0.07969 0.1564-0.14484 0.38092-0.18066 0.81933-0.03676 0.45004-0.03711 1.03228-0.03711 1.88868l0 8.40039c0 0.85639 0.00035 1.43863 0.03711 1.88867 0.03582 0.43842 0.10097 0.66294 0.18066 0.81933 0.19173 0.37625 0.49777 0.68229 0.87403 0.87403 0.1564 0.07969 0.38092 0.14484 0.81933 0.18066 0.45004 0.03676 1.03228 0.03711 1.88868 0.03711l8.40039 0c0.85639 0 1.43863-0.00035 1.88867-0.03711 0.43842-0.03582 0.66294-0.10097 0.81933-0.18066 0.37625-0.19173 0.68229-0.49777 0.87403-0.87403 0.07969-0.1564 0.14484-0.38092 0.18066-0.81933 0.03676-0.45004 0.03711-1.03228 0.03711-1.88867l0-8.40039c0-0.85639-0.00035-1.43863-0.03711-1.88868-0.03582-0.43841-0.10097-0.66294-0.18066-0.81933-0.19173-0.37625-0.49777-0.68229-0.87403-0.87403-0.1564-0.07969-0.38092-0.14484-0.81933-0.18066-0.45004-0.03676-1.03228-0.03711-1.88867-0.03711l-8.40039 0z'

const AIDA_ICON_MASK_IMAGE = `url("data:image/svg+xml,${encodeURIComponent(
  `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><g transform="translate(2 2)"><path fill="#fff" fill-rule="evenodd" clip-rule="evenodd" d="${AIDA_ICON_PATH}"/></g></svg>`,
)}")`

const AIDA_ICON_MASK_STYLE = {
  WebkitMaskImage: AIDA_ICON_MASK_IMAGE,
  maskImage: AIDA_ICON_MASK_IMAGE,
  WebkitMaskSize: 'contain',
  maskSize: 'contain',
  WebkitMaskRepeat: 'no-repeat',
  maskRepeat: 'no-repeat',
  WebkitMaskPosition: 'center',
  maskPosition: 'center',
} as const

export function AidaIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(2, 2)">
        <path fillRule="evenodd" clipRule="evenodd" d={AIDA_ICON_PATH} fill="currentColor" />
      </g>
    </svg>
  )
}

export function AidaIconAurora({ className }: { className?: string }) {
  return (
    <span
      aria-hidden
      className={tw(
        'inline-block shrink-0 bg-gradient-aurora bg-[length:200%_auto] motion-safe:animate-aurora',
        className,
      )}
      style={AIDA_ICON_MASK_STYLE}
    />
  )
}
